module.exports = __webpack_public_path__ + "img/tn-timeline-main-12.b37dd6fe.jpg";